import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import reducer from './redux';
import { thunk } from 'redux-thunk';
import { BUILD } from './utils/config';
import { DEV_ENVIRONMENT } from './utils/constants';

const composeEnhancers =
  (BUILD === DEV_ENVIRONMENT && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const configureStore = (state) => {
  const store = createStore(
    reducer,
    (state && state.initialState) || {},
    composeEnhancers(applyMiddleware(thunk))
  );

  if (import.meta.hot) {
    import.meta.hot.accept('./redux', (newModule) => {
      if (newModule) {
        store.replaceReducer(newModule.default);
      }
    });
  }

  return store;
};

export const store = configureStore({});
export default configureStore;
